import React from 'react';
import OptimizedImagesManagement from './OptimizedImagesManagement';
import { showSuccessToast } from '../utils/toast';

/**
 * Optimized Images Page Component
 * TASK 2: Separate page for optimized images management
 * Extracted from OptimizePage tabs
 */
function OptimizedImagesPage() {
  // Handle job started callback - will be passed to Dashboard for job UI
  const handleJobStarted = (jobId) => {
    // Store job ID in sessionStorage so Dashboard can pick it up
    const existingJobs = JSON.parse(sessionStorage.getItem('optimizationJobs') || '[]');
    if (!existingJobs.includes(jobId)) {
      existingJobs.push(jobId);
      sessionStorage.setItem('optimizationJobs', JSON.stringify(existingJobs));
    }
    
    // TASK 1: Store flag to indicate this redirect was triggered by optimization API success
    const scrollFlag = { jobId, timestamp: Date.now() };
    sessionStorage.setItem('scrollToJob', JSON.stringify(scrollFlag));
    
    // Trigger custom event for Dashboard to listen
    window.dispatchEvent(new CustomEvent('jobStarted', { detail: { jobId } }));
    
    // TASK 2: Show toast notification using global helper (auto-hides after 3 seconds)
    showSuccessToast('Optimization job started successfully');
    
    // Redirect to dashboard
    setTimeout(() => {
      // Update URL to dashboard
      window.history.pushState({}, '', '/');
      // Trigger page change event (App.js listens to popstate)
      window.dispatchEvent(new PopStateEvent('popstate'));
    }, 100);
  };

  return (
    <s-section>
      <s-stack gap="base">
        <s-heading>Optimized Images</s-heading>
        <OptimizedImagesManagement onJobStarted={handleJobStarted} />
      </s-stack>
    </s-section>
  );
}

export default OptimizedImagesPage;

